import styled from 'styled-components';

export const VendorGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  width: 100%;
  background: white;
  padding: 0 16px 24px;
  /* Apply margin-bottom to all children except the last one */
  & > *:not(:last-child) {
    margin-bottom: 8px;
  }
  /* Remove margin for specific child when present */
  & > .vendorIntegrations__darwin {
    margin: 0;
  }
`;

export const ContactFormPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
`;
